exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-reportContentLayout-GraphSettings-infoSection{-webkit-box-shadow:0 0 1px rgba(0,0,0,.5);box-shadow:0 0 1px rgba(0,0,0,.5);color:gray;border:2px solid #b3b3b3 !important;border-radius:0 !important;padding:0 10px 0;margin-bottom:20px}.src-components-reportContentLayout-GraphSettings-infoSection .src-components-reportContentLayout-GraphSettings-toggle{padding:10px}.src-components-reportContentLayout-GraphSettings-infoSection .src-components-reportContentLayout-GraphSettings-dataBlock{padding:0 10px 0}", ""]);

// exports
exports.locals = {
	"infoSection": "src-components-reportContentLayout-GraphSettings-infoSection",
	"toggle": "src-components-reportContentLayout-GraphSettings-toggle",
	"dataBlock": "src-components-reportContentLayout-GraphSettings-dataBlock"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportContentLayout/GraphSettings/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportContentLayout/GraphSettings/styles.scss
// module chunks = 1